import http from '../api/base'
import home from '../api/home'

let fbqFb = function name(FbqIdList,types, type = 'index') {
    ! function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    // FbqIdList = FbqIdList.split(';');
    // console.log('=====FbqIdList====', FbqIdList)
    if(!types){
        FbqIdList.forEach((item, index) => {
            fbq('init', item);
            var testdiv1 = document.getElementById("id1");
            testdiv1.innerHTML+= '<img height="1" width="1" style="display:none"  src="https://www.facebook.com/tr?id='.concat(item).concat('&ev=PageView&noscript=1"/>')
            var testdiv2 = document.getElementById("id2");
            testdiv2.innerHTML+= '<img height="1" width="1" style="display:none"  src="https://www.facebook.com/tr?id='.concat(item).concat('&ev=ViewContent&noscript=1"/>')
        })
    }else{
        FbqIdList.forEach((item, index) => {
            fbq('init', item);
            var testdiv2 = document.getElementById("id2");
            testdiv2.innerHTML+= '<img height="1" width="1" style="display:none"  src="https://www.facebook.com/tr?id='.concat(item).concat('&ev=ViewContent&noscript=1"/>')
        })
    }
    
    // fbq('track', 'PageView');
    // if (type != 'cart') {
    //     // console.log('====fbq-ViewContent===', fbq)
    //     fbq('track', 'ViewContent');
    // }


    // <noscript> 
    //     < img height = "1"
    // width = "1"
    // style = "display:none"
    // src = "https://www.facebook.com/tr?id=265353487810067&ev=PageView&noscript=1" /
    //     > < /noscript>
}
let getFbqId = function(type,res) {
    // let host = location.host; //线上
    // home.shopId(host).then((res) => {
        if (res) {
            http({
                method: "get",
                url: `/info`,
                params: {
                    shopId: res
                }
            }).then((res) => {
                sessionStorage.setItem("FbqIdList", res);
                fbqFb(res, type)
            })
        }
    // })

}
export default {
    fbqFb,
    getFbqId
}


// WEBPACK FOOTER //
// ./src/fbq/fbq.js